import CardsFactory from './CardsFactory';

export default CardsFactory;
